export const getters = {
  hasSelectedItems(state) {
    return !!state.selectedItems && state.selectedItems.length > 0;
  },
  chosenSequence(state) {
    return state.selectedItems;
  },
};
